// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__0D1uq","spin":"Spinner_spin__i8gjo"};